'use strict';

exports.__esModule = true;
exports.ProjectsAutocompleteView = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp2; // import Autocomplete, { styles as stylesProto } from 'autocomplete';
// import Avatar from 'Avatar';
// import { withState } from 'recompose';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _List = require('material-ui/List');

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _materialUi = require('material-ui');

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Done = require('material-ui-icons/Done');

var _Done2 = _interopRequireDefault(_Done);

var _Clear = require('material-ui-icons/Clear');

var _Clear2 = _interopRequireDefault(_Clear);

var _context = require('@prisma-cms/context');

var _context2 = _interopRequireDefault(_context);

var _Object = require('./Object');

var _Object2 = _interopRequireDefault(_Object);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = {
  menuListItemText: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    fontWeight: "normal",
    fontSize: "1rem" // const projectsQuery = gql`
    //   query projects(
    //     $where: ProjectWhereInput!
    //     $orderBy: ProjectOrderByInput
    //   ){
    //     projects(
    //       where: $where
    //       orderBy: $orderBy
    //     ){
    //       id
    //       projectname
    //       firstname
    //       lastname
    //       fullname
    //       photo
    //     }
    //   }
    // `;

  }
};
var ProjectsAutocompleteView = exports.ProjectsAutocompleteView = (_temp2 = _class = function (_Component) {
  _inherits(ProjectsAutocompleteView, _Component);

  function ProjectsAutocompleteView() {
    var _temp, _this, _ret;

    _classCallCheck(this, ProjectsAutocompleteView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      // value: "",
      // project: undefined,
      opened: false // onChange(event) {
      //   const {
      //     value,
      //   } = event.target;
      //   this.setState({
      //     value,
      //   }, () => this.loadData());
      // }
      // async loadData() {
      //   const {
      //     value,
      //   } = this.state;
      //   const {
      //     client,
      //     query: {
      //       projects: projectsQuery,
      //     },
      //   } = this.context;
      //   // console.log("projectsQuery", projectsQuery);
      //   // return null;
      //   const {
      //     exclude,
      //   } = this.props;
      //   let objects = [];
      //   let $query = value;
      //   let where = {
      //     name_contains: $query
      //   };
      //   if (exclude && exclude.length) {
      //     where.id_not_in = exclude;
      //   }
      //   if (value) {
      //     objects = await client.query({
      //       query: gql(projectsQuery),
      //       variables: {
      //         where,
      //       },
      //     })
      //       .then(r => {
      //         const {
      //           objects,
      //         } = r.data;
      //         return objects;
      //       })
      //       .catch(console.error);
      //   }
      //   this.setState({
      //     objects,
      //   });
      // }
      // async submit() {
      //   const {
      //     project,
      //   } = this.state;
      //   const {
      //     onSubmit,
      //   } = this.props;
      //   await onSubmit(project)
      //     .catch(console.error);
      //   this.resetData();
      // }
      // resetData() {
      //   this.setState({
      //     project: null,
      //     value: "",
      //     objects: [],
      //   });
      // }

    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ProjectsAutocompleteView.prototype.renderItem = function renderItem(item) {
    var name = item.name;
    return name;
  };

  ProjectsAutocompleteView.prototype.render = function render() {
    var _this2 = this;

    var Autocomplete = this.context.Autocomplete;

    var _props = this.props,
        classes = _props.classes,
        onSubmit = _props.onSubmit,
        objects = _props.data.objects,
        value = _props.value,
        objectId = _props.objectId,
        onSelect = _props.onSelect,
        resetData = _props.resetData,
        other = _objectWithoutProperties(_props, ['classes', 'onSubmit', 'data', 'value', 'objectId', 'onSelect', 'resetData']);

    var opened = this.state.opened;
    var items = [];

    if (objects) {
      objects.map(function (n) {
        var value = n.id,
            label = n.name;
        items.push(_extends({}, n, {
          value: value,
          label: label
        })); // items.push(project);
      });
    }

    return _react2.default.createElement(Autocomplete, _extends({}, other, {
      // onChange={event => this.onChange(event)}
      value: value || "",
      items: items,
      onSelect: onSelect,
      onMenuVisibilityChange: function onMenuVisibilityChange(opened) {
        return _this2.setState({
          opened: opened
        });
      },
      renderInput: !opened && objectId ? // props => {
      //   return <div
      //     style={{
      //       display: "flex",
      //       flexDirection: "row",
      //       flexWrap: "nowrap",
      //       alignItems: "center",
      //     }}
      //   >
      //     {this.renderItem(project)} {onSubmit ?
      //       <IconButton
      //         style={{
      //           width: 34,
      //           height: 34,
      //         }}
      //         onClick={event => this.submit()}
      //       >
      //         <DoneIcon
      //           style={{
      //             color: "green",
      //           }}
      //         />
      //       </IconButton>
      //       : null
      //     }
      //     <IconButton
      //       style={{
      //         width: 34,
      //         height: 34,
      //       }}
      //       onClick={resetData}
      //     >
      //       <ClearIcon
      //         style={{
      //           color: "red",
      //         }}
      //       />
      //     </IconButton>
      //   </div>
      // }
      function (props) {
        return _react2.default.createElement('div', {
          style: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap",
            alignItems: "center"
          }
        }, _react2.default.createElement(_Object2.default, {
          where: {
            id: objectId
          }
        }), ' ', onSubmit ? _react2.default.createElement(_IconButton2.default, {
          style: {
            width: 34,
            height: 34
          },
          onClick: function onClick(event) {
            return _this2.submit();
          }
        }, _react2.default.createElement(_Done2.default, {
          style: {
            color: "green"
          }
        })) : null, _react2.default.createElement(_IconButton2.default, {
          style: {
            width: 34,
            height: 34
          },
          onClick: resetData
        }, _react2.default.createElement(_Clear2.default, {
          style: {
            color: "red"
          }
        })));
      } : undefined,
      renderItem: function renderItem(item, isHighlighted, style) {
        // const text = getItemText(item);
        var label = item.label;
        var text = label;
        return _react2.default.createElement(_List.ListItem, {
          key: item.value,
          className: [classes.menuListItem, isHighlighted || item.label === value || item.value === value ? "actived" : ""].join(" ")
        }, _react2.default.createElement('div', {
          className: classes.menuListItemText
        }, _this2.renderItem(item)));
      }
    }));
  };

  return ProjectsAutocompleteView;
}(_react.Component), _class.contextType = _context2.default, _temp2); // export default ProjectsAutocompleteView;

ProjectsAutocompleteView.propTypes = process.env.NODE_ENV !== "production" ? {
  classes: _propTypes2.default.object.isRequired,
  // Кого исключить из результатов поиска
  exclude: _propTypes2.default.array,
  // Выполнение при подтверждении
  onSubmit: _propTypes2.default.func,
  onSelect: _propTypes2.default.func.isRequired,
  resetData: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.string.isRequired,
  // item: PropTypes.object,
  objectId: _propTypes2.default.string
} : {};
exports.default = (0, _materialUi.withStyles)(styles)(function (props) {
  return _react2.default.createElement(ProjectsAutocompleteView, props);
});